import React, { FunctionComponent, memo } from "react";
import { isEqual } from "lodash";


import AlgorithmReport from "./AlgorithmReport";
import { IAlgorithmReport } from "./types";
import { Flex } from "@chakra-ui/react";


interface IProps {
  reports: IAlgorithmReport[];
}


const AlgorithmReports: FunctionComponent<IProps> = memo(function AlgorithmReports({
  reports = [],
}) {
  return <>
    <Flex
      direction="column"
      mt={2}
    >
      {reports.map((report, i) => (
        <AlgorithmReport key={i} report={report} />
      ))}
    </Flex>
  </>
}, isEqual);

export default AlgorithmReports;
